'use strict';


//wait for the document to be ready
document.addEventListener('DOMContentLoaded', ()=> {
  init();
});


function init () {
  accordion();
  splitMainMenuLinks();
  triggerSlickForCarousel_40_60();
  preventAddToCart();
  triggerChannelAdvisor();
  observeTable();
  coloredHeadings();
  convertComparisonTable();
  monitorLanguageSwitcher();
}
window.addEventListener('load', function() {
  wrapLegalMarks();
});

function triggerSlickForCarousel_40_60() {
  const body = document.querySelector('body');
  const carousels = document.querySelectorAll('.edgewell-slick-slider');

  if(!carousels || carousels.length < 1) return;

  carousels.forEach(carousel => {
    const slickSliderPreview = carousel.querySelector('.slick-slider__preview');
    if (!slickSliderPreview) return;

    const slides = carousel.querySelectorAll('.slick-slider-item');
    const slickSetting_showArrows_desktop = slickSliderPreview.getAttribute('data-edgewellslick-show-arrows-desktop') === 'true';
    const slickSettings = {
      slidesToShow_desktop: 1,
      slidesToShow_mobile: 1,
      showArrows_desktop: slickSetting_showArrows_desktop,
      showArrows_mobile: false
    }




    $(slickSliderPreview).slick({
      slidesToShow: slickSettings.slidesToShow_desktop,
      slidesToScroll: 1,
      arrows: slickSetting_showArrows_desktop,
      fade: false,
      responsive: [
        {
          //breakpoint 1500px and below
          breakpoint:1500,
          settings: {
            arrows: false,
            infinite: false,
            dots: true,
            slidesToShow: 1
          }
        }
      ]
    });

    if(slides.length < 2) {
      hideSlickDot(carousel);
    }

  })

}
function hideSlickDot(carousel) {
  const slickDots = carousel.querySelector('.slick-dots');
  if (!slickDots) return;

  slickDots.style.display = 'none';
}

function preventAddToCart() {
  const addToCartBtns = document.querySelectorAll('.ProductForm__AddToCart');

  if(addToCartBtns.length < 1) return;

  document.addEventListener('click', (evt) => {
    let btn = evt.target.closest('.ProductForm__AddToCart');
    if (!btn) return
    evt.preventDefault();
  })

}
function triggerSlickForModals (){
  const body = document.querySelector('body');

  if(!body) return;

  body.addEventListener('click', evt => {
    const modalTriggerBtn = evt.target.closest('button[data-modal-content-id^="leadership_"]');
    if (!modalTriggerBtn) return

    const slickSliderPreview = document.querySelector('#js-modal .slick-slider__preview');
    const slickSliderThumbs = document.querySelector('#js-modal .slick-slider__thumbnails');

    if (!slickSliderPreview || !slickSliderThumbs) return;
    $('#js-modal .slick-slider__preview').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
    });
    $('#js-modal .slick-slider__thumbnails').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '#js-modal .slick-slider__preview',
      infinite: true,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      arrows: false
    });
  })
}
function assignClassToParent (element, closestParent, className) {
  if (!element) return;

  if (element.closest(closestParent)) {
    element.closest(closestParent).classList.add(className);
  }
}
function toggleAccordion(trigger,target) {
  if (trigger.getAttribute('aria-expanded') === 'true'){
    target.setAttribute('data-visible', 'false');
    trigger.setAttribute('aria-expanded', 'false');
  }
  else {
    target.setAttribute('data-visible', 'true');
    trigger.setAttribute('aria-expanded', 'true');
  }
}
function accordion() {
  const accordionHeaders = document.querySelectorAll('[data-accordion-header]');

  if (!accordionHeaders) return;

  accordionHeaders.forEach(header => {

    const accordionBody = document.getElementById(header.getAttribute('aria-controls'));

    //Add a click event listener to the header
    header.addEventListener('click', () => {
      toggleAccordion(header,accordionBody);
    });
  });
}
function splitMainMenuLinks() {
  const mainMenu = document.getElementById('shopify-section-header');
  if (!mainMenu) return

  const mainMenuLinks = mainMenu.querySelectorAll('.Header__Wrapper.split-links .Header__FlexItem.region-one ul li.HorizontalList__Item');
  if (!mainMenuLinks) return

  const totalLinks = mainMenuLinks.length;
  //We want to find split point. And since arrays start at 0, we need to subtract 1 from the total;
  const splitPoint = (Math.ceil(totalLinks / 2) - 1);
  mainMenuLinks[splitPoint].classList.add('spacer');

}

function triggerChannelAdvisor() {

  var modal = document.getElementById("caWtbModal");
  var btn = document.getElementById("caWtbBtn");
  var btnQv = document.getElementById("qvWtbButton");
  var span = document.getElementById("caWtbClose");
  var locale = {
    shopLang: document.documentElement.getAttribute("data-lang"),
    isoCode: document.documentElement.getAttribute("data-localization-iso-code"),
  }
  if (btn !== null) {
    btn.onclick = function() {
      var modelNumber = btn.getAttribute('data-model');
      modal.classList.toggle("modal-open");
      document.getElementById("caWtbIframe").src = `https://where-to-buy.co/widgets/core/shoppable/index.html?pid=12044582&model=${modelNumber}${locale.shopLang !== "en" ? "&lang="+locale.shopLang : ""}`;
    }
  }
  if (btnQv !== null) {
    btnQv.onclick = function() {
      var modelNumberQV = btnQv.getAttribute('data-model');
      modal.classList.toggle("modal-open");
      document.getElementById("caWtbIframe").src = "https://where-to-buy.co/widgets/core/shoppable/index.html?pid=12044582&model=" + modelNumberQV;
    }
  }
  span.onclick = function() {
    modal.classList.toggle("modal-open");
  }
  window.onclick = function(event) {
    if (event.target === modal) {
      modal.classList.toggle("modal-open");
    }
  }
  /********
   Change WTB `data-model` attribute when variant changes - START
   ********/
  const productForm = document.querySelector('.ProductForm');
  let currentUrl = window.location;


  //Listen for user to select a variant, then get the variant ID from URL
  document.addEventListener ('click', (e) => {
    const selectedVariant = e.target.classList.contains('Popover__Value');
    if (!selectedVariant) return;

    let selectedVariantID = currentUrl.search.replace('?variant=', '');
    getVariantDetails(selectedVariantID).then((data) => {
      const barcode = data.barcode;
      updateWTBButton('data-model', barcode);
    });
  });

  async function getVariantDetails(variantID) {
    try {
      const response = await fetch(`/variants/${variantID}.json`)
      if (!response.ok) {
        throw new Error(`Network error. Can't retrieve variant details: ${response.status}`);
      }
      const data = await response.json();
      return data.product_variant
    } catch (err) {
      console.log('Fetching data failed:', err);
    }
  }

  function updateWTBButton(attribute,value) {
    let wtbButton = document.querySelector('.caWtbBtn');
    if (!wtbButton) return;
    wtbButton.setAttribute('data-mm-ids',value);
  }
  /********
   Change WTB `data-model` attribute when variant changes - END
   ********/
}

function convertComparisonTable() {
  let lang = document.documentElement.getAttribute('data-lang')

  let text_yes, text_no;

  if (lang === 'fr') {
    text_yes = 'oui';
    text_no = 'non';
  } else {
    text_yes = 'yes';
    text_no = 'no';
  }
  const comparisonSnippet = document.querySelector('.edgewell-snippets--playtexComparison');
  if (!comparisonSnippet) return;
  const comparisonTable = comparisonSnippet.querySelector('table');

  const tableCells = comparisonTable.querySelectorAll('td');

  tableCells.forEach(cell => {
    if (lang === 'fr') {
      if (cell.textContent.toLowerCase() === text_yes) {
        convertTextToDot(cell,'Oui')
      }
      if (cell.textContent.toLowerCase() === text_no) {
        convertTextToDot(cell,'Non')
      }
    } else {
      if (cell.textContent.toLowerCase() === text_yes) {
        convertTextToDot(cell,'Yes')
      }
      if (cell.textContent.toLowerCase() === text_no) {
        convertTextToDot(cell,'No')
      }
    }
  });
  function convertTextToDot(cell,string) {
    const innerCellSpan = document.createElement('span');
    innerCellSpan.classList.add('chart--dot');
    innerCellSpan.classList.add(`chart--${string.toLowerCase()}`);
    innerCellSpan.classList.add('text--center');
    innerCellSpan.setAttribute('title', string.toUpperCase());
    innerCellSpan.style.position = 'relative';
    innerCellSpan.style.cursor = 'pointer';
    const innerCellSpanText = document.createElement('span');
    innerCellSpanText.classList.add('sr-only');
    innerCellSpanText.style.color = 'black';
    innerCellSpanText.style.backgroundColor = 'white';
    innerCellSpanText.textContent = string.toUpperCase();
    cell.textContent = '';
    cell.appendChild(innerCellSpan);
    innerCellSpan.appendChild(innerCellSpanText);
  }


}

function observeTable() {
  const observableTables = document.querySelectorAll('[data-edgewell-observer-overflow="true"]');
  const toleranceBeforeEdge = 40;
  if (observableTables.length === 0) return;
  observableTables.forEach(table => {
    const tableWrapper = table.querySelector('.table-container__innerWrapper');
    const overflowTable = table.querySelector('table');
    toggleOverlay(tableWrapper, overflowTable, toleranceBeforeEdge, 'hide-overflow-gradient');
    tableWrapper.addEventListener('scroll', function () {
      // console.log('scrolling');
      toggleOverlay(tableWrapper, overflowTable, toleranceBeforeEdge, 'hide-overflow-gradient');
    });

    function toggleOverlay(parent, child, tolerance, className) {
      if ((child.getBoundingClientRect().right - tolerance) <= parent.getBoundingClientRect().right) {
        table.classList.add(className);
      } else {
        table.classList.remove(className);
      }
    }
  });
}

function wrapLegalMarks() {
  let lang = document.documentElement.getAttribute('data-lang')

  const markByLang = {
    "en": ["®"],
    "fr": ["MC","MD"],
  }
  const classNames = [
    ".ArticleItem__Excerpt",
    ".Faq__Question",
    ".Header__MainNav",
    ".ProductItem__Title",
    ".ProductMeta__Title",
    ".Rte",
    ".SidebarMenu__Nav.SidebarMenu__Nav--primary",
    ".Slideshow__Content",
    ".article-focus__excerpt",
    ".callout-card-item__content",
    ".collectionHeader--title",
    ".icon-callout__header",
    ".section--liquid",
    ".section--simple-text-columns .block-item--content",
    ".slick-slider-item",
    ".static-focus__excerpt",
  ];

  const marksInScope = markByLang[lang];
  classNames.forEach(className => {
    const elements = document.querySelectorAll(className);
    if (elements.length === 0) return;
    elements.forEach(element => {
      marksInScope.forEach(targetMark => {
        const text = element.innerHTML;
        const regex = new RegExp(targetMark, 'g');
        const matches = text.match(regex);

        if (matches === null) return
        const newString = text.replace(regex, `<sup data-edgewell-jsSwapped>${targetMark}</sup>`);
        element.innerHTML = newString;
      })


      //clean up any double `<sup>` which may have been created in process
      const supers = element.querySelectorAll('sup');
      supers.forEach(sup => {
        if (sup.parentNode.nodeName === 'SUP') {
          //ORIGINAL - Changed temporarily to fix issues with items in span being colored 'hotpink' when in a header
          // const span = document.createElement('span');

          // NEW
          const newDiv = document.createElement('div');

          newDiv.classList.add('display-inline-block');
          newDiv.innerHTML = sup.parentNode.innerHTML;
          sup.parentNode.parentNode.replaceChild(newDiv,sup.parentNode);
        }
      })
    })
  })

    setTimeout(function () {

    }, 3000);

}


function coloredHeadings() {
  const headings = document.querySelectorAll('h1,h2,h3,h4,h5,h6');
  const splitCharacters = [
    ':',
    '|'
  ]
  headings.forEach(heading => {
    const text = heading.textContent;
    let splitCharacterFound = false;
    splitCharacters.forEach(splitCharacter => {
      if(text.includes(splitCharacter)) {
        splitCharacterFound = true;
      }

      if (!splitCharacterFound) return;

      const splitText = text.split(splitCharacter);
      const textAfterSplitter = splitText[1].trim();
      const newTextAfterSplitter = `<span>${textAfterSplitter}</span>`;
      heading.innerHTML = heading.innerHTML.replace(textAfterSplitter, newTextAfterSplitter);
    })

  });
}

/*This function monitors the language switcher located in header, inorder to update z-index for entire header,
 when page overlay is visible*/
function monitorLanguageSwitcher() {
  const headerLanguageSwitcher = document.querySelector('.language-switcher__header');
  const header = document.getElementById('shopify-section-header');
  if (!headerLanguageSwitcher || !header) return;

  const languageSwitcherBtn = headerLanguageSwitcher.querySelector('.SelectButton');
  if (!languageSwitcherBtn) return;

  const languagePopOver = document.getElementById(languageSwitcherBtn.getAttribute('aria-controls'));

  const config = {
    attributes: true,
    childList: false,
    subtree: false
  }

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes" && mutation.attributeName === "aria-expanded") {
        const ariaExpanded = mutation.target.getAttribute('aria-expanded');

        if (ariaExpanded === "true") {
          header.style.zIndex='20'
        } else {
          header.style.zIndex='';
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(languageSwitcherBtn,config)

  //Assume user has no need to switch language after 1 min.
    setTimeout(() => {
        observer.disconnect();
    }, 60000);
}

